export const ALL_ROLE_RESOURCES = ['VIEW_VENDOR_SUBTOTAL'];
export const ACTION_RESOURCES = [
  'RECON_VENDOR_ACTION',

  'NEW_MANUAL_BILLING',
  'UPLOAD_MANUAL_BILLING',
  'UPDATE_MANUAL_BILLING',
  'PROCESS_MANUAL_BILLING',

  'UPDATE_RECON_VENDOR_DATA',
  'NEW_VMX',
  'UPDATE_VMX',
  'NEW_VENDOR_TERMS',
  'UPDATE_VENDOR_TERMS',
  'UPDATE_VENDOR_BILLING_DATA',
  'ACTIVATE_MANUAL_RECORD',
  'DEACTIVATE_MANUAL_RECORD',
];

export const MANAGER_ACTION_RESOURCES = [
  'APPROVE_REJECT_VENDOR',
  'RESET_VENDOR',
  'REPROCESS_VENDOR',
];

export const USER_ROLES = {
  RECONADMIN: 14,
  BILLINGSPECIALIST: 13,
  BILLINGMANAGER: 15,
  VIEWER: 16,
};

export const ROLE_RESOURCES = {
  [USER_ROLES['RECONADMIN']]: [
    ...ALL_ROLE_RESOURCES,
    ...ACTION_RESOURCES,
    ...MANAGER_ACTION_RESOURCES,
  ],
  [USER_ROLES['BILLINGSPECIALIST']]: [
    ...ALL_ROLE_RESOURCES,
    ...ACTION_RESOURCES,
  ],
  [USER_ROLES['BILLINGMANAGER']]: [
    ...ALL_ROLE_RESOURCES,
    ...ACTION_RESOURCES,
    ...MANAGER_ACTION_RESOURCES,
  ],
  [USER_ROLES['VIEWER']]: [...ALL_ROLE_RESOURCES],
};
